/* eslint import/prefer-default-export: "off" */

import _ from 'lodash';

export const getCustomValue = (customValue, data = null, defaultValue = '') => {
  let output = customValue;
  const patterns = customValue.match(/\[(.*?)\]/g);
  let variants = [];
  if (patterns) {
    _.each(patterns, (pattern) => {
      variants = pattern
        .replace(/\[|\]/g, '')
        .split('|')
        .map(item => item.trim());
      /* eslint consistent-return: "off" */
      let result = defaultValue;
      _.each(variants, (variant) => {
        const value = _.get(data, variant, null);
        if (value !== null) {
          result = _.isArray(value) ? value.join(', ') : value.toString();
          return false;
        }
      });
      output = output.replace(pattern, result);
    });
  }
  else {
    output = defaultValue;
  }
  return {output, variants};
};

export const getFields = (fieldData) => {
  switch (fieldData.field_type) {
    case 'custom': {
      const fields = [];
      const {variants} = getCustomValue(fieldData.custom_value);
      _.each(variants, (variant) => {
        const parts = variant.split('.');
        if (parts.length) {
          fields.push(parts[0]);
        }
      });
      return {[fieldData.custom_value]: fields};
    }
    default:
      return {[fieldData.name]: fieldData.name};
  }
};

// Fields shown by default in the results lists: {fieldName: 1} for every field with enabled_default.
export const defaultEnabledFields = fields => _.transform(fields, (result, field) => {
  if (field.enabled_default) {
    result[field.name] = 1;
  }
}, {});

export function prepareActionsFields(fields, enabledFields = {}) {
  const mainActionFields = ['folio', 'id'];
  const extraActions = {};
  const subQueries = {};
  _.each(fields, (field) => {
    if (_.get(enabledFields, field.name, false)) {
      const keyedField = getFields(field);
      const fieldKey = Object.keys(keyedField)[0];
      const fieldName = keyedField[fieldKey];
      if (field.other_action_enabled && field.other_action) {
        const variable = field.field_type === 'subquery' ? subQueries : extraActions;
        variable[field.other_action] = variable[field.other_action] || {
          fields: {},
          filters: {},
          fieldsSettings: {},
        };
        variable[field.other_action].fields[fieldKey] = fieldName;
        variable[field.other_action].fieldsSettings[fieldKey] = field;
        // Add extra filters params for Zonar type.
        if (field.other_action === '_zonar') {
          variable[field.other_action].filters = {
            zonar_action: 'property-record',
            getSummary: 'true',
            land_use_request: 1,
          };
        }
      }
      else {
        mainActionFields.push(fieldName);
      }
    }
  });
  return {mainActionFields, extraActions, subQueries};
}
